const TrailSelection = ({ trailsData,selectedTrail, onSelectTrail }) => {
  return (
    <div>
      <h2>Select a Trail:</h2>
      <div className="trail-thumbnails">
        {trailsData.map((trailInfo) => (
          <div
            key={trailInfo.name}
            className={`trail-thumbnail ${selectedTrail === trailInfo.name ? 'selected' : ''}`}
            onClick={() => onSelectTrail(trailInfo.name)}>
            <img src={trailInfo.imgSrc} alt={`${trailInfo.name} Trail`} />
          </div>
        ))}
      </div>
    </div>
  )
}

export default TrailSelection
